export default "__VITE_ASSET__DbUeUNd1__"